import ProTextInput from "../../../../Components/Inputs/TextField";
import ProSelectInput from "../../../../Components/Inputs/SelectField"
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";
import DateField from "../../../../Components/Inputs/DateField";

const ProjectDetailsRequestedInfoSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  documentType,
  handleDateValidation,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    { key: "projectAcresSize", type: "text" },
    { key: "constructionSiteCounties", type: "text" },
    { key: "totalConstructionDays", type: "text" },
    { key: "targetConstructionStartDate", type: "date" },
    { key: "projectCapacityAC", type: "text" },
    { key: "projectCapacityDC", type: "text" },
    { key: "targetCODDate", type: "date", extraProps: { shouldDisableDate: handleDateValidation } },
    { key: "documentType", type: "select", options: documentType },
  ];

  const renderField = ({ key, type, options, extraProps }) => {
    const config = formConfig[key];
    const permission = fieldPermission(key);
    const commonProps = {
      key,
      ...defaultFormProps,
      ...config,
      permission,
      ...(extraProps || {}),
    };

    switch (type) {
      case "select":
        return <ProSelectInput {...commonProps} options={options} />;
      case "date":
        return <DateField {...commonProps} />;
      default:
        return <ProTextInput {...commonProps} />;
    }
  };

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible title="Project Details (Requested Info)">
        {fields.map(renderField)}
      </FormSectionWrapper>
    )
  );
};

export default ProjectDetailsRequestedInfoSection;
